import residentalBuildingTypes from './residentalBuildingTypes';
import buildingLength from './shortestBuildingLength';
import { isASCE716 } from '__common/constants/buildingCodes';

export const getASCE716SfmBuildingDescriptionResidentalAdditionalInputs = (buildingCode: number, missing = undefined) => {
  buildingLength.missing = missing;
  return (isASCE716(buildingCode) ? [residentalBuildingTypes, buildingLength] : [buildingLength]);
};
